module.exports = __webpack_public_path__ + "img/POT-alt.380001aa.svg";